<template>
  <el-dialog
    :close-on-click-modal="false"
    title="发货"
    :visible.sync="visible"
    width="400px"
    class="remarkDialog"
    :before-close="handleClose"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="108px">
      <el-form-item label="订单编号：">
        {{ this.orderData.appNo }}
      </el-form-item>
      <el-form-item label="商家账号：">
        {{ this.orderData.operNo }}
      </el-form-item>
      <el-form-item prop="shippingMethodName" label="物流名称：">
        <el-input
          :disabled="true"
          v-model="form.shippingMethodName"
          class="input"
          size="small"
        />
      </el-form-item>

      <el-form-item prop="trackingNumber" label="运单号：">
        <el-input v-model="form.trackingNumber" class="input" size="small" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">返回</el-button>
      <el-button type="primary" @click="sure" size="small"> 确定 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex"
import { sendByHand } from "@/api/order/all"

export default {
  name: "RemarkDialog",
  data() {
    return {
      form: {
        shippingMethod: "",
        shippingMethodName: "",
        appId: "",
        trackingNumber: "",
      },
      isReadOnly: false,
      rules: {
        shippingMethodName: [
          { required: true, message: "请输入物流名称", trigger: "blur" },
        ],
        trackingNumber: [
          { required: true, message: "请输入运单号", trigger: "blur" },
        ],
      },
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    orderData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
    visible() {
      if (this.visible) {
        this.form = {
          shippingMethod: "",
          shippingMethodName: "",
          appId: "",
          trackingNumber: "",
        }
        if (this.orderData.expreList && this.orderData.expreList.length > 0) {
          this.form.shippingMethod = this.orderData.expreList[0].shippingMethod
          this.form.shippingMethodName = this.orderData.expreList[0].shippingMethodName
        }

        if (
          this.orderData.orderSource == "01" ||
          this.orderData.orderSource == "02"
        ) {
          this.form.shippingMethod = this.orderData.skuList[0].shippingProvider
          this.form.shippingMethodName = this.orderData.skuList[0].shippingProvider
          this.form.trackingNumber = this.orderData.skuList[0].trackingCode
          this.isReadOnly = true
        }
      }
    },
  },
  methods: {
    sure() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.appId = this.orderData.appId
          sendByHand(this.form).then((response) => {
            if (response.code == "200") {
              this.msgSuccess("保存成功！")
            } else {
              this.msgError("提交失败！")
            }
            this.$emit("onClose", this.form)
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    handleClose() {
      this.$emit("onClose")
    },
  },
}
</script>

<style scoped>
.remarkDialog {
  font-size: 12px;
}

.item {
  display: flex;
  flex-wrap: wrap;
}

.color {
  padding: 1px;
  margin: 3px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 4px;
  border: 1px solid #eee;
}

.color.active {
  border: 1px solid #333;
}

.color-inner {
  width: 32px;
  height: 32px;
  border-radius: 4px;
}
</style>
